export default {
  // Meta Tags (for social media previews)
  metaTitle: '{{petName}} 的照護資訊',
  metaDescription: '查看 {{petName}} 的詳細照護資訊，包含飲食、健康、行為等重要資料',
  
  // Loading & Error States
  loadingPet: '載入寵物資料中...',
  petInfoNotFound: '找不到寵物資訊',
  linkExpiredOrIncorrect: '此分享連結已過期或不正確',
  backToHome: '返回首頁',
  
  // Age & Time
  year: '歲',
  years: '歲',
  month: '個月',
  months: '個月',
  unknown: '未知',
  
  // Security
  securityReminder: '安全提醒',
  shareOnlyWithTrusted: '這份資料包含您寵物的個人資料，請僅與您信任的照護者分享。'
};